export class ChartPoint {

    public y: number;
    public name: any;
    public color: string;

    constructor(jsonData?: any) {
        if (jsonData) {
            this.y = jsonData['Value'];
            this.name = jsonData['Name'];
            this.color = jsonData['Color'];
        }
    }
}
